import { render, staticRenderFns } from "./TransferBookingData.vue?vue&type=template&id=6893343a&scoped=true"
import script from "./TransferBookingData.vue?vue&type=script&lang=js"
export * from "./TransferBookingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893343a",
  null
  
)

export default component.exports